import * as React from "react";

import { Divider } from "@busbud/horizon";

import { LineItem } from "@app/components/trip-fare-summary/line-item";
import { useAppContext } from "@app/helpers/hooks";

import type { ConnectorProps as Props } from "./redeem-credits.connect";

export const RedeemCreditsLine = ({ redeemed_amount, currency }: Props) => {
  const { translator } = useAppContext();

  if (!redeemed_amount || !currency) {
    return null;
  }

  return (
    <div data-testid="redeem-credits-line" className="mb-200">
      <Divider className="my-200" />
      <LineItem
        label={translator.t("!checkout.loyalty.redeemed-credits")}
        amount={redeemed_amount}
        currency_code={currency}
        negative
      />
    </div>
  );
};
